module.exports = __webpack_public_path__ + "e5dd868df4bbe8841a212dc8d1efb58f.ttf";